import { createAsyncThunk } from '@reduxjs/toolkit';
import { LocationCoordinate } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindLocationCoordinate } from './interface';

export const findLocationCoordinate = createAsyncThunk(
  'locationCoordinate/findLocationCoordinate',
  async (values: FindLocationCoordinate, { rejectWithValue }) => {
    try {
      const response = await LocationCoordinate.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);